import { $authHost } from '.';

// Выдает список пациентов, добавленных врачом
export const getPatients = async () => {
    const { data } = await $authHost.get('/patients/');

    // **Ответ (200 OK):**
    // ```json
    // [
    //   {
    //     "id": 1,
    //     "user_id": 2,
    //     "birthdate": "1990-05-15",
    //     "therapies": [
    //       {
    //         "id": 1,
    //         "patient": 1,
    //         "doctor": 1,
    //         "device": 1,
    //         "started_at": "2024-01-15T10:00:00Z",
    //         "ended_at": null,
    //         "o2_flow": 2.5,
    //         "spo2_target": 95,
    //         "notes": "Лечение кислородом"
    //       }
    //     ]
    //   }
    // ]
    // ```

    return data;
};

export const createPatient = async (
    first_name,
    last_name,
    patronymic,
    birthdate,
    email,
    phone,
    sex
) => {
    //     **Запрос:**
    // ```json
    // {
    //   "first_name": "Анна",
    //   "last_name": "Петрова",
    //   "patronymic": "Сергеевна",
    //   "birthdate": "1985-03-20",
    //   "email": "petrova@example.com",
    //   "phone": "+79997654321",
    //   "sex": "F"
    // }
    // ```
    const patient = {
        first_name: first_name,
        last_name: last_name,
        patronymic: patronymic,
        birthdate: birthdate,
        email: email,
        phone: phone,
        sex: sex,
    };
    const { data } = await $authHost.post('/patients/', patient);
    return data;
};

export const getOnePatient = async (patientId) => {
    const { data } = await $authHost.get(`/patients/${patientId}/`);
    return data;
};

export const updatePatient = async (patientId, patient) => {
    const { data } = await $authHost.put(`/patients/${patientId}/`, patient);
    return data;
};

export const deletePatient = async (patientId) => {
    const { data } = await $authHost.delete(`/patients/${patientId}/`);
    return data;
};

// Получить информацию о пользователе пациента
export const getPatientUser = async (patientId) => {
    const { data } = await $authHost.get(`/patients/${patientId}/user/`);
    return data;
};

// Получить терапии пациента
export const getPatientTherapies = async (patientId) => {
    const { data } = await $authHost.get(`/patients/${patientId}/therapies/`);
    return data;
};

// Получить профиль болезни пациента
export const getPatientIllnessProfile = async (patientId) => {
    const { data } = await $authHost.get(`/patients/${patientId}/illness-profile/`);
    return data;
};

// export const connectUserToPatient = async (patientId) => {
//     try {
//         const response = await $authHost.get(`/patient/${patientId}/user`);

//         if (
//             response.data.code === 'unauthorized' ||
//             response.data.code === 'not_found' ||
//             response.data.code === 'forbidden'
//         ) {
//             throw new Error(response);
//         }

//         const user = response.data;
//         return user;
//     } catch (e) {
//         console.error('Connecting user to patient failed:', e);
//     }
// };

